let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("dsiAd"), load("4t5t3")]).then(() => parcelRequire('lYlbz'));